// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__XY9j1","empty":"ModalGraph_empty__2FyLT"};